<template>
  <div class="sf-user-bubble">
    <div class="sf-user-bubble__text">{{ text }}</div>
  </div>
</template>

<script>
export default {
  name: 'UserBubble',
  props: {
    text: { type: String, required: true },
  },
};
</script>

<style lang="scss" scoped>
.sf-user-bubble {
  align-self: flex-end;
  max-width: 280px;
  animation: sf-user-msg-appear 0.25s cubic-bezier(0.16, 1, 0.3, 1) both;

  &__text {
    background: #517b86;
    color: #fff;
    border-radius: 10px 10px 0 10px;
    padding: 12px 16px;
    font-size: 15px;
    font-family: 'Comfortaa', sans-serif;
    line-height: 1.5;
  }
}

@keyframes sf-user-msg-appear {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
